:host {
  display: block;
}



/* variables to control new cookie banner */
/* Coop as a default */
#usercentrics-root {
  --uc-layer-border-radius: 5px;
  --uc-layer-border-top-style: solid;
  --uc-layer-border-top-width: 5px;
  --uc-layer-border-top-color: #F59C00;
  --uc-layer-padding: calc(50px - 24px) calc(32px - 24px) 0 calc(32px - 24px);

  /* start defaults by usercentrics */
  --uc-layer-margin: 0 auto;
  --uc-layer-min-height: auto;
  /* end defaults by usercentrics */

  --uc-layer-width: 635px;
  --uc-layer-max-width: 635px;
  --uc-layer-height: 610px;

  @media (max-width: 769px) {
    --uc-layer-height: auto;
    --uc-layer-margin: auto;
    --uc-layer-max-width: calc(100% - (16px * 2));
    --uc-layer-width: 100%;
  }

  --uc-logo-width: auto;
  --uc-logo-height: 24px;

  --uc-title-color: #333333;
  --uc-title-font: var(--base-font-02);
  --uc-title-font-size: 28px;
  --uc-title-font-weight: 800;
  --uc-title-line-height: 38.13px;

  --uc-message-color: #808080;
  --uc-message-font: var(--base-font-01);

  --uc-action-button-font: var(--base-font-02);
  --uc-action-button-font-weight: 400;
  --uc-action-button-font-size: 16px;
  --uc-action-button-line-height: 26px;
  --uc-action-button-padding: 12px 0;

  --uc-tab-button-font: var(--base-font-02);
  --uc-tab-button-font-size: 14px;
  --uc-tab-button-font-weight: 400;
  --uc-tab-button-active-font-weight: 700;
  --uc-tab-button-line-height: 26px;

  --uc-links-font: var(--base-font-02);
  --uc-links-font-weight: 400;
  --uc-links-font-size: 14px;
  --uc-links-line-height: 26px;
  --uc-links-text-decoration: underline;

  --uc-card-title-font-size: 13px;
  --uc-card-title-font-weight: 400;
  --uc-card-title-line-height: 17px;

  --uc-footer-padding: 32px 24px 32px 24px;

  @media (max-width: 769px) {
    --uc-footer-padding: 25px 17px;
  }

}
